import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DOC_TYPE_ALIAS } from '../../../config/helpers';

import Picture from '../Picture';

const propTypes = exact({
  ctaText: PropTypes.string,
  description: PropTypes.string,
  documentTypeAlias: PropTypes.string.isRequired,
  image: PropTypes.object,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

const defaultProps = {
  ctaText: 'Read more',
  description: null,
  image: null,
};

function PromotedPage(props) {
  return (
    <article className="PromotedItem">
      {props.image && (
        <Picture
          {...props.image}
          className="PromotedItem_image"
          sizes={[
            [100, 1.77], // from 0
            [50, 1.77], // from 480
            [33, 1.77], // from 768
            [33, 1.77], // from 1024
            ['480px', 1.77], // from 1440
          ]}
        />
      )}
      <div className="PromotedItem_body">
        {props.documentTypeAlias === DOC_TYPE_ALIAS.NEWS_ARTICLE && (
          <div className="PromotedItem_subtitle">News</div>
        )}
        <div className="PromotedItem_title">{props.title}</div>
        {props.description && <div className="PromotedItem_description">{props.description}</div>}
      </div>
      <div className="PromotedItem_buttonContainer">
        <a href={props.url} className="PromotedItem_button Button Button-ghost">
          <span className="Button_text">{props.ctaText}</span>
        </a>
      </div>
    </article>
  );
}

PromotedPage.propTypes = propTypes;
PromotedPage.defaultProps = defaultProps;

export default PromotedPage;
